import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { redirectus } from 'ggApp/modules/router/actions';
import { user as userSelector } from 'ggApp/modules/auth/selectors';
import CheckoutModal from './CheckoutModal';

const enhanced = connect(
    createStructuredSelector({
        user: userSelector,
    }),
    (dispatch) => ({
        redirectus: bindActionCreators(redirectus, dispatch),
    }),
);

export default enhanced(CheckoutModal);
